import { FC, useState, MouseEvent } from "react";
import style from "./style.module.scss";
import { FolderProps } from "./type";
import { Collapsible } from "./collapsible";

export const Folder: FC<FolderProps> = (props) => {
  const { node, selected, handleFolderSelect } = props;
  const { name, children } = node;
  const [isOpen, setOpen] = useState(false);

  const toggleClick = () => setOpen((prev) => !prev);

  const handleNameClick = (event: MouseEvent) => {
    event.stopPropagation();
    handleFolderSelect(node);
  };

  const isSelected = node.fullPath === selected?.fullPath;

  return (
    <div className={style.folder}>
      <div
        className={`${style["folder--label"]} ${
          isSelected ? "bg-info-subtle" : ""
        }`}
      >
        <div onClick={toggleClick}>
          <i
            className={
              isOpen ? "bi bi-caret-down-fill" : "bi bi-caret-right-fill"
            }
          />
          <i className={isOpen ? "bi bi-folder2-open" : "bi bi-folder"} />
        </div>
        <p onClick={handleNameClick}>{name}</p>
      </div>
      <Collapsible isOpen={isOpen}>
        {children.map((f, i) => (
          <Folder
            key={i}
            node={f}
            selected={selected}
            handleFolderSelect={handleFolderSelect}
          />
        ))}
      </Collapsible>
    </div>
  );
};
